var uniqueProdNamesArray = [];

collectionGetVariations = function(filteredDataProducts) {
	var variantPrice = [];
	var variantCompareAtPrice = [];

	var prodsWithVariants = [];

	var newlyLoadedProdsWithVariants = [];

	var newlyLoadedProdsHtml;

	var pageProducts = $(".product");

	var productPriceClass = ".product-price";
	var productClass = ".product-col";

	var filteredDuplicateProducts = [];

	var lowestPrice;
	var highestPrice;
	var highestCompareAtPrice;

	var allPrices = [];
	var allCompareAtPrices = [];

	var variantsPriceRanges = false;
	var variantsSamePrices = false;

	var htmlOutput = '';

	var percentOff;

	var htmlSaleLabel = '<p class="product-sale-tag">' + theme.strings.sale + '</p>';

	var currentProductPrice = '';
	var currentProductCompareAtPrice = '';
  
    var hideDuplicates = $('.product-grid-list').data('hideDuplicates');


	if (filteredDataProducts) {
		pageProducts = $(filteredDataProducts).filter('.product');
	}


	function checkArrValueSameness(array){
		return !array.some(function(value, index, array){
			return value !== array[0];
		});
	}

	function saleHtmlOutput(compareAtPrice, price, percentOff, hasPriceDifference) {
		var upToLabel = hasPriceDifference ? 'up to ' : '';
		var selectColoursLabel = hasPriceDifference ? 'select colours |' : '';
		var saleRes = [];

		if(hasPriceDifference) {
			saleRes = [
				"<p>",
				selectColoursLabel + " " + upToLabel + percentOff + "% off",
				"</p>"
			];
		}
		
		return saleRes.join("");
	}


	function checkIfSale(mainProd) {
		lowestPrice = 0;
		highestPrice = 0;
		highestCompareAtPrice = 0;

		allPrices = [];
		allCompareAtPrices = [];

		variantsPriceRanges = false;
		variantsSamePrices = false;

		htmlOutput = '';

		percentOff = 0;

		currentProductPrice = $(mainProd).eq(0).find(productPriceClass).data('price');
		currentProductCompareAtPrice = $(mainProd).eq(0).find(productPriceClass).data('compare-at-price');

		allPrices.push(currentProductPrice);

		if(currentProductCompareAtPrice > 0) {
			allCompareAtPrices.push(currentProductCompareAtPrice);
		}

		$(mainProd).eq(0).find('.variant-price').each(function(){
			if($(this).data('variant-price') > 0){
				allPrices.push($(this).data('variant-price'));
			}
		});


		$(mainProd).eq(0).find('.variant-compare-at-price').each(function(){
			if($(this).data('variant-compare-at-price') > 0) {
				allCompareAtPrices.push($(this).data('variant-compare-at-price'));
			}
		});

		// console.log(allCompareAtPrices);

		if(allPrices.length > 0) {
			lowestPrice = Math.min.apply(Math, allPrices);

			highestPrice = Math.max.apply(Math, allPrices);
		}

		if(allCompareAtPrices.length > 0){
			highestCompareAtPrice = Math.max.apply(Math, allCompareAtPrices);
		}


		if (highestCompareAtPrice > 0) {
			var largestPrice;

			var arePricesTheSame = checkArrValueSameness(allPrices);

			if(arePricesTheSame === true) {
				console.log('all sale');

				percentOff = Math.round((currentProductCompareAtPrice - currentProductPrice) * 100 / currentProductCompareAtPrice);

				htmlOutput = saleHtmlOutput(currentProductCompareAtPrice, currentProductPrice, percentOff, false);
		 
				$(mainProd).eq(0).find(".price-additional-info").html(htmlOutput);
			}
			else {
				percentOff = Math.round((highestCompareAtPrice - lowestPrice) * 100 / highestCompareAtPrice);
				
				htmlOutput = saleHtmlOutput(highestCompareAtPrice, lowestPrice, percentOff, true);

				$(mainProd).eq(0).find(".price-additional-info").html(htmlOutput);
			}
		}
	}

	function getColourSwatch(p, currentMainProduct, currentMainProductName,indexCount ) {
       var colorHax = null;
        for(let i = 0; i < p.tags.length; i++) {
            if(p.tags[i].startsWith('#')){
             colorHax = p.tags[i];
            }
        }
      if(p.available == true ){
		var colourHtml =["<div class='swatch-wrapper' style='width: 14px !important; height: 14px;'>",
		"<a href='"+ p.url +"' data-swatch-variant-price="+p.price+" style='border:none' data-swatch-variant-compare-at-price="+p.compare_at_price+"  data-swatch-prod-name='" + p.handle + "' class='swatch no-border swatch-"+ p.handle + "' data-swatch-is-variant='true' data-swatch-image='" + theme.Images.getSizedImageUrl(p.featured_image, '540x') + "'>",
		"<span class='sr-only'>" + p.title.trim() + "</span>",
		"<span class='swatch no-border swatch-circle' style='background-color: "+ colorHax + ";border-radius: 7px;border:none '></span>",
		"</a></div>\n\r"
		].join("");
        $(currentMainProduct).find(".colour-swatches").append(colourHtml);
      } 
	}

	function getPrices(p, currentMainProduct, currentMainProductName){
		$(currentMainProduct).find(".variant-prices").append("<div data-prod-for-price='" + p.handle + "' class='variant-price' data-variant-price="+p.price+" data-variant-compare-at-price="+p.compare_at_price+"> </div>");
	}

	function getFeaturedImage(p, currentMainProduct) {
		if(p.featured_image != null) {
			$(currentMainProduct).find(".product-images").append("<div class='product-image product-image-swatch image-"+p.handle+"'><a href='"+ p.url +"' class='product-featured-image'><img src='"+ p.featured_image +"' alt='"+p.featured_image.alt+"' /></a></div>\n\r");
		}
	}

	function ajaxGetInfo(productColourHandlesArray, currentMainProduct, currentMainProductName, index) {
		var colourHandleName = '';

		jQuery.getJSON('/products/'+productColourHandlesArray+'.js', function(p) {
			if(p.available == true) {
              	var indexCount = parseInt(index) + 1;
              
				colourHandleName = productColourHandlesArray;

				getColourSwatch(p, currentMainProduct, currentMainProductName,indexCount);

				getFeaturedImage(p, currentMainProduct, currentMainProductName);

				getPrices(p, currentMainProduct, currentMainProductName);

				attachImages(p, currentMainProduct, currentMainProductName);

				prodsWithVariants.push(currentMainProductName);

			}
		});
	}

	function attachImages(p, currentMainProduct) {
		if(p.images.length > 0) {
			for(let i = 0; i < p.images.length; i++) {
				$(currentMainProduct).find(".product-image-slick").append("<img src='"+ p.images[i] +"' data-image-color='" + p.handle + "'/>");
			}
		}
	}

	function getVariantInfo() {
		if(filteredDuplicateProducts.length > 0){
			pageProducts = filteredDuplicateProducts;
		}

		$(pageProducts).each(function(){

			var currentMainProductName = $(this).find(".product-card").data('prod-name');

			var productInfo = $(this).find(".product-card").data('product-info');
			var currentMainProduct = $(this);

			var productColourHandles = $(this).find(".product-card").attr("data-product-other-colour-handles");

			var currentMainProdPrice = $(this).find(".product-price").data('prod-price');
			var currentMainProdCompareAtPrice = $(this).find(".product-price").data('compare-at-price');
            var productColourHandlesArray = [];

			if(productColourHandles) {
				productColourHandlesArray = $.trim(productColourHandles).split(" ");
			}
			else {
				productColourHandlesArray = [];
			}

			variantHandles = [];

			if(productColourHandlesArray.length > 1) {
				for(var i = 0; i < productColourHandlesArray.length; i++) {

					if(productInfo !== productColourHandlesArray[i]) {
						ajaxGetInfo(productColourHandlesArray[i], currentMainProduct, currentMainProductName, i, productColourHandlesArray.length);
					}

				}
             
                
			}

		})
	}

	function checkForDuplicates(){
		$(pageProducts).each(function(){
			var addProdName = $(this).find(".product-card").data('prod-name');
			if(uniqueProdNamesArray.indexOf(addProdName) > -1) {
				$(this).remove();
			}
			else {
				uniqueProdNamesArray.push(addProdName);
				filteredDuplicateProducts.push(this);
			}
		});
	}

	function update() {
		setTimeout(function(){

			for(var j = 0; j < prodsWithVariants.length; j++) {
				checkIfSale($('[data-prod-name="'+prodsWithVariants[j]+'"]'));
			}

			//make the colour swatches a slider and update colour counter label
			$(".colour-swatches").not(".product-colour-swatches").each(function() {

				// if($(this).find(".swatch-wrapper").length > 1) {
				// 	var swatchContainer = $(this);

				// 	if(!swatchContainer.hasClass("slick-initialized")) {
				// 		var count = swatchContainer.closest(".product-card-content").find(".grid-view-item--color-counter");
				// 		count.find("[data-colour-counter-number]").text(swatchContainer.find(".swatch-wrapper").length);
	
				// 		count.show();
	
				// 		swatchContainer.slick({
				// 			slidesToShow: 4,
				// 			arrows: true,
				// 			speed: 300
				// 		})
				// 	}
				// } else {
				// 	$(this).remove();
				// }
			})

			$(".swatch-wrapper").not(".product-colour-swatches").hover(function() {
				var parentProduct = $(this).closest(".product-card");
				var swatchImage = $(this).find(".swatch").data("swatchImage");
				var imageContainer = parentProduct.find(".product-card__image-wrapper");
				if(swatchImage) {
					imageContainer.append("<img class='product-card__image-variant' src='" + swatchImage + "'/>");
				}
			}, function() {
				$(this).closest(".product-card").find(".product-card__image-variant").remove();
			})

			quickShopClickInit();

			// $(".swatch-wrapper").click(function(){
				
			// 	var parentProduct = $(this).closest(".product");
			// 	var swatchName = $(this).find('.swatch').attr('class').split(' ')[1];
			// 	var colorName = swatchName.replace('swatch-', '');
			// 	var currentSwatch = '.' + $(this).find('.swatch').attr('class').split(' ')[1];
			// 	var findImage = '.image-' + colorName;
			// 	var isVariant = $(this).find('.swatch').data('swatchIsVariant');

			// 	var swatchPrice = $(this).find('.swatch').data('swatchVariantPrice');
			// 	var swatchCompareAtPrice = $(this).find('.swatch').data('swatchVariantCompareAtPrice')
				

			// 	parentProduct.find(".product-image-swatch").css({"z-index": "-1", "opacity": "0"});

			// 	parentProduct.find(findImage).css({"z-index": "2", "opacity": "1"});
			// 	filterImagesForSwatch(colorName, $(this));

			// 	if(isVariant) {
			// 		parentProduct.find('.product-price').css("display", "none");
			// 		parentProduct.find('.variant-prices').html(generatePriceHTML(swatchPrice, swatchCompareAtPrice));
					
			// 	} else {
			// 		parentProduct.find('.product-price').css("display", "");
			// 		parentProduct.find('.variant-prices').html(null);
			// 	}
			// });
		}, 1000);
	}

	function filterImagesForSwatch(colour, currentProd) {
		var slickContainer = $(currentProd).closest(".product-card").find(".product-image-slick");
		$(slickContainer).slick('slickUnfilter');
		$(slickContainer).slick('slickFilter','[data-image-color="' + colour + '"]');
	}

	function generatePriceHTML(price, compareAt) {
		var onSale = price < compareAt ? true : false;

		var saleClasses = onSale ? 'price--on-sale' : '';

		var html = '<dl class="product-price justify-content-center price ' + saleClasses + '" data-price="" data-prod-price="' + price + '" data-compare-at-price="' + compareAt + '"><div class="price__regular"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><span class="price-item price-item--regular" data-regular-price="">' + theme.Currency.formatMoney(price, theme.moneyFormat) + '</span></dd></div><div class="price__sale"><dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt><dd><span class="price-item price-item--sale" data-sale-price="">' + theme.Currency.formatMoney(compareAt, theme.moneyFormat) +'</span><span class="price-item__label sr-only" aria-hidden="true">Sale</span></dd></div></dl>';

		return html;
	}

	
	$(document).ajaxStop(function () {
		update();

		// $(".product-image-slick").each(function() {
		// 	// if($(this).hasClass('slick-initialized') == false) {
		// 		$(this).not('.slick-initialized').slick({
		// 			slidesToShow: 1,
		// 			slidesToScroll: 1,
		// 			speed: 300,
		// 			arrows: true,
		// 			prevArrow: $(this).parent().find(".slideshow-block-slides-arrow-left"),
		// 			nextArrow: $(this).parent().find(".slideshow-block-slides-arrow-right")
		// 		})
		// 	// }
        // });
	});

	update();

  if(hideDuplicates && hideDuplicates === true) {
    checkForDuplicates();
  }
	

	getVariantInfo();
};
